import { render, staticRenderFns } from "./itmo.vue?vue&type=template&id=73ec6c62&"
import script from "./itmo.vue?vue&type=script&lang=js&"
export * from "./itmo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports